import { useMemo } from 'react';
import { useLastReadModule } from '../../context/LastReadContext';
import { LAST_READ_MODULES } from './lastReadModules';
import { isChatRoomUnread } from './lastReadUtils';

/** Room list ids that have unread activity (boolean dot, not message counts). */
export function useChatRoomUnreadIds(rooms) {
  const { lastReadMap } = useLastReadModule(LAST_READ_MODULES.CHAT);

  return useMemo(
    () => rooms.filter((room) => isChatRoomUnread(room, lastReadMap)).map((room) => room.id),
    [rooms, lastReadMap],
  );
}
